export default {
  'periodic-subscription:main-title': 'REGULAR DELIVERY',
  'periodic-subscription:descripton':
    'With a subscription, you enjoy all the benefits of our numerous products - from food to accessories for your pet.',
  'periodic-subscription:why-subscribe': 'WHY SUBSCRIBE?',
  'periodic-subscription:manage-subscription':
    'EASY MANAGEMENT OF YOUR SUBSCRIPTION',
  'periodic-subscription:manage-subscription-description':
    'You can easily adjust your regular deliveries with just a few clicks in your account under "My Account".',
  'periodic-subscription:subscribe-benefit': 'SUBSCRIBE NOW AND BENEFIT',
};
